import { render, staticRenderFns } from "./PlaceUsers.vue?vue&type=template&id=ac4d08ee&"
import script from "./PlaceUsers.vue?vue&type=script&lang=js&"
export * from "./PlaceUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports